import { body } from '@utilities/dom-elements'

export default function etmcCartEvent(cartItems) {
  if (window._etmc) {
    const { userEmail, mid } = body.dataset

    if (mid) window._etmc.push(['setOrgId', mid])
    if (userEmail !== 'null') window._etmc.push(['setUserInfo', { email: userEmail }])
    window._etmc.push(['trackCart', { cart: cartItems.length ? formatEtmcCart(cartItems) : [] }])
  }
}

function formatEtmcCart(items) {
  return items.map((obj) => ({
    item: obj.id,
    quantity: obj.quantity.toString(),
    price: obj.price.sales.formatted,
    unique_id: obj.id,
  }))
}
